<!-- Page Content -->
<main id="mainBodyContainer" class="container">
    <div class="col-md-8 col-12 mx-auto my-5 px-3">
        <h1 class="mb-3 mt-0">APA's Demographic Questionnaire</h1>
  
        <!-- ******************** BEGIN: MAIN PAGE CONTENT ******************** -->
        <div class="mb-0">
            <div id="submitted" class="row">
                <div class="col-sm-12 py-3">
                    <div class="card mb-3">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12 px-4 pt-2">
                                    <p>
                                        Sorry, somthing went wrong! Your data was not successfully submitted.
                                    </p>
                                    <p>
                                        You can alway come back and try fill the Questionnaire
                                    </p>
                                    <p><strong>You can now close this window.</strong></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </main>
  
  